<div *ngIf="!isLoading" class="global-container">
  <app-top-nav [user]="user"></app-top-nav>
  <div class="global-container__content">
    <router-outlet *ngIf="isAuth && user"></router-outlet>
    <ng-container *ngIf="!user">
      <div class="content" fxLayout="row">
        <mat-card class="content card-error" fxLayoutGap="5pt" fxLayoutAlign="start center" fxFlex="50">
          <mat-icon class="material-icons">error</mat-icon>
          <span><b>If you encountered a sign-in issue. Please contact support.</b></span>
        </mat-card>
      </div>
    </ng-container>
  </div>
  <app-footer></app-footer>
</div>
<app-loading *ngIf="isLoading"></app-loading>
